package br.com.htms.inspeccaocampo.data.os

// GERADO por scripts/pgr_extract.py — não editar à mão.
// Fonte: 2026 - PGR HTMS Energia Ltda (Rev.11).pdf

internal const val PGR_FONTE = "2026 - PGR HTMS Energia Ltda (Rev.11).pdf"

internal val PGR_RISCOS_UNIDADE: List<PgrRisco> = listOf(
    PgrRisco(
        grupo = "Ergonômico",
        perigo = "Condições de Trabalho",
        danos = "Desconforto",
        epc = emptyList(),
        epi = emptyList(),
        medidasAdm = "Inspeção do TST em campo"
    ),
    PgrRisco(
        grupo = "Ergonômico",
        perigo = "Demandas de Trabalho",
        danos = "Sobrecarga mental, estresse ocupacional, ansiedade, burnout, fadiga mental",
        epc = emptyList(),
        epi = emptyList(),
        medidasAdm = "Apoio psicológico disponibilizado aos colaboradores"
    ),
    PgrRisco(
        grupo = "Ergonômico",
        perigo = "Equilibrio Vida Pessoal X Trabalho",
        danos = "Burnout",
        epc = emptyList(),
        epi = emptyList(),
        medidasAdm = "Disponibilização de benefício TotalPass (qualidade de vida) Apoio psicológico ao colaborador"
    ),
    PgrRisco(
        grupo = "Ergonômico",
        perigo = "Jornada de trabalho",
        danos = "Exaustão",
        epc = emptyList(),
        epi = emptyList(),
        medidasAdm = "Controle de jornada e horas extras"
    ),
    PgrRisco(
        grupo = "Ergonômico",
        perigo = "Liderança e Gestão",
        danos = "Assédio",
        epc = emptyList(),
        epi = emptyList(),
        medidasAdm = "Disponibilização de canal com RH e apoio psicológico"
    ),
    PgrRisco(
        grupo = "Ergonômico",
        perigo = "Planejamento do trabalho",
        danos = "Ansiedade",
        epc = emptyList(),
        epi = emptyList(),
        medidasAdm = "APR diária antes do início das atividades"
    ),
    PgrRisco(
        grupo = "Ergonômico",
        perigo = "Relações Interpessoais",
        danos = "Conflitos",
        epc = emptyList(),
        epi = emptyList(),
        medidasAdm = "Acompanhamento psicológico quando necessário"
    ),
    PgrRisco(
        grupo = "Ergonômico",
        perigo = "Saúde e Bem Estar",
        danos = "Adoecimento",
        epc = emptyList(),
        epi = emptyList(),
        medidasAdm = "Monitoramento via exames ocupacionais"
    ),
    PgrRisco(
        grupo = "Acidente",
        perigo = "Acidente de trajeto",
        danos = "Ferimentos superficiais, entorses, fraturas, morte.",
        epc = emptyList(),
        epi = emptyList(),
        medidasAdm = "Treinamento de ordem de serviço, procedimentos operacionais internos"
    ),
    PgrRisco(
        grupo = "Acidente",
        perigo = "Incêndio",
        danos = "Queimaduras / amputação / Morte.",
        epc = listOf("Extintores"),
        epi = emptyList(),
        medidasAdm = "Treinamento de Brigada de Incêndio, Treinamento de Ordem de serviço"
    )
)

internal val PGR_SETORES: List<PgrSetor> by lazy {
    listOf(pgrSetor01(), pgrSetor02(), pgrSetor03(), pgrSetor04(), pgrSetor05(), pgrSetor06(), pgrSetor07(), pgrSetor08(), pgrSetor09(), pgrSetor10(), pgrSetor11(), pgrSetor12(), pgrSetor13(), pgrSetor14(), pgrSetor15(), pgrSetor16(), pgrSetor17(), pgrSetor18())
}

private fun pgrSetor01() = PgrSetor(
    ghe = 1,
    nome = "Administrativo",
    descricao = "Realiza atividades de cunho administrativo",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "Suporte para computadores, treinamento de ordem de serviço"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área administrativa",
            danos = "Acidentes: Torções, Ferimentos leves. Posturas incorretas: Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = ""
        )
    ),
    cargos = listOf(
        PgrCargo("Analista Administrativo", "Executar atividades relativas a processos administrativos financeiros, tais como: gestão de pessoas, materiais, contratos, sistemas de informações, compras para aquisição de materiais, bens ou serviços em canteiro de obras, Organizar e realizar inspeções em alojamentos, prospectar e cadastrar fornecedores diversos."),
        PgrCargo("Analista de Departamento Pessoal JR", "Executa tarefas mais operacionais, como o processamento de folha de pagamento, administração de benefícios e atendimento inicial aos funcionários"),
        PgrCargo("Analista de TI", "Atender chamados de suporte em informática, registrando e acompanhando as solicitações até a solução, Prestar suporte técnico a usuários em hardware, software, redes e sistemas corporativos, Criação de usuários de email. Identificar, diagnosticar e resolver incidentes e problemas de TI, Realizar a instalação, configuração e atualização de sistemas operacionais e aplicativos, Controlar e manter o inventário de equipamentos e licenças de software, Apoiar a configuração e manutenção de impressoras, dispositivos móveis e periféricos, Monitorar a conectividade e o desempenho da rede local, Manter atualizados os procedimentos técnicos e a base de conhecimento do service desk, Garantir a aplicação das políticas de segurança da informação,"),
        PgrCargo("Aprendiz administrativo", "Auxiliar na organização e arquivamento de documentos físicos e digitais, Apoiar no controle e atualização de planilhas e relatórios administrativos, Realizar a digitalização de documentos e inserção de dados em sistemas internos, Acompanhar e auxiliar no controle de correspondências e materiais de escritório, Prestar suporte às áreas administrativa, financeira, de recursos humanos e demais setores, conforme necessidade, Apoiar no atendimento telefônico e presencial, direcionando solicitações aos responsáveis, Cumprir com os requisitos do programa de aprendizagem, participando de cursos e treinamentos obrigatórios."),
        PgrCargo("Assistente administrativo", "Elaboram, participam da elaboração e implementam política de saúde e segurança no trabalho (sst), realizam auditoria, acompanhamento e avaliação na área, identificam variáveis de controle de doenças, acidentes, qualidade de vida e meio ambiente. Desenvolvem ações educativas na área de saúde e segurança no trabalho, participam de perícias e fiscalizações e integram processos de negociação. Participam da adoção de tecnologias e processos de trabalho, gerenciam documentação de sst, investigam, analisam acidentes e recomendam medidas de prevenção e controle."),
        PgrCargo("Assistente administrativo JR", "Executam serviços de apoio nas áreas de recursos humanos, administração, finanças e logística, atendem fornecedores e clientes,"),
        PgrCargo("Assistente de Recursos Humanos", "Dar suporte nas rotinas diárias do departamento pessoal, Realizar cadastro de admissão, Acompanhar e fazer conferência de ponto, Controle de férias, Elaborar e controlar documentos e planilhas do setor, Suporte a atividades de recrutamento e seleção, Acompanhar processos de integração e desligamento, suporte administrativo para equipes em obras, Realizar atendimento a colaboradores, dar suporte às açoes estratégicas da área."),
        PgrCargo("Assistente Departamento Pessoal", "Separar documentação e realizar o input em plataformas de clientes, (holerites, cartões pontos, contratos, fichas, termos, comprovantes de pagamento e afins). Pesquisar e salvar os comprovantes de pagamento no banco Santander para anexo nos portais ou até mesmo envio aos colaboradores. Realizar ajustes de ponto como lançamento de atestados, ajustes de marcações, cadastro e desligamentos dentro do sistema. Realizar o fechamento de ponto e exportação para envio a contabilidade. Elaborar planilha com os efetivos de obra justamente para ter certeza de onde o colaborador está alocado e vinculado ao portal correto. Separar os holerites e pontos por obra para que eles sejam devolvidos com assinatura. Retirar dúvidas seja do colaborador ou dos administrativos de obra orientando e dando suporte."),
        PgrCargo("Assistente Financeiro", "Receber e lançar notas fiscais em sistema, Atualizar planilhas financeiras, Preparar balanços, Acompanhar e reconciliar extratos bancários, Criar relatórios de análises de custos, Processar pagamentos de impostos, Registrar contas a pagar e a receber , Processar faturas e fazer acompanhamento com clientes, fornecedores e parceiros quando necessário, Participar de auditorias"),
        PgrCargo("Estagiário (a)", "Gerenciar e organizar documentos relacionados à obra, Gerenciar o controle de ponto dos colaboradores, assegurando o correto registro de horas trabalhadas, folgas e horas extras, Realizar a integração de novos colaboradores, Dar suporte administrativo e de RH à equipe de campo, solucionando questões operacionais e administrativas, Facilitar a comunicação entre o escritório e o canteiro de obras, garantindo que as informações fluam de maneira eficiente e rápida.")
    )
)

private fun pgrSetor02() = PgrSetor(
    ghe = 2,
    nome = "Almoxarifado",
    descricao = "Responsável por gerenciar o recebimento, armazenamento, controle e distribuição de materiais e produtos",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo"),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "AET (Analise Ergonômica do trabalho) Responsável pela Elaboração do AET Ezequiel Cabral de Souza Lima Medico do Trabalho CRM 24773-SC / RQE 15303"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança", "Calçado de segurança tipo botina", "Luva Látex nitrílico", "Luva de Neolatex"),
            medidasAdm = "Treinamento de ordem de serviço, procedimento operacional interno, Ficha de entrega de EPI´s"
        )
    ),
    cargos = listOf(
        PgrCargo("Almoxarife", "Receber, transportar e estocar produtos, ferramentas e equipamentos. Receber e conferir notas fiscais de entrada, Verificar quantidade e qualidade de materiais. Receber, transportar e alocar materiais e produtos, Catalogar e gerenciar estoque de materiais e produtos, Transferir (se necessário) materiais e produtos da empresa para outros centros de custo. Controlar estoque e comunicar ao superior direto a baixa de materiais ou produtos, Verificar estado dos materiais/equipamentos/ferramentas que giram pelo setor. Comunicar superior direto da necessidade de conserto/manutenção dos itens com defeito ou avaria."),
        PgrCargo("Assistente de almoxarifado", "Envio e recebimento de materiais Controle da entrada e saída dos produtos, materiais e insumos Solicitação de reposição de materiais Distribuição de EPls aos colaboradores Cuidar da limpeza e organização do almoxarifado Preencher planilhas e relatórios de controle Organizar mercadorias"),
        PgrCargo("Auxiliar de Almoxarifado Jr III", "Reportando-se ao Líder de Almoxarifado recebe, confere, estoca e/ou atende requisições de materiais diversos destinados à produção, manutenção, equipamentos de proteção individual e outros atualizando os registros de entrada e saída, para controle.")
    )
)

private fun pgrSetor03() = PgrSetor(
    ghe = 3,
    nome = "Elétrica",
    descricao = "Serviços de instalações elétricas",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo", "Protetor auditivo auricular Tipo Concha"),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "AET (Analise Ergonômica do trabalho) Responsável pela Elaboração do AET Ezequiel Cabral de Souza Lima Medico do Trabalho CRM 24773-SC / RQE 15303"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Contato com eletricidade",
            danos = "Queimadura por choque elétrico, ferimentos, parada cardíaca e/ou arritmia, morte.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calça de segurança em tecido antichama", "Calçado de segurança", "Camisa Risco II Anti chama", "Capacete com ABA", "Capacete de Segurança ultra master", "Luva de segurança confeccionada em raspa", "Luva isolante de Borracha"),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em altura",
            danos = "Morte, Poli traumatismos (Contusões/Fraturas).",
            epc = emptyList(),
            epi = listOf("Capacete Classe B", "Capacete classe E suspensão com jugular", "Capacete de Segurança ultra master", "Cinto de Seg.tipo Paraquedista e Talabarte de Segurança", "Cinto de Segurança tipo Paraquedista com Talabarte y", "Óculos de Proteção"),
            medidasAdm = "Treinamento de NR 35 aos colaboradores. PTA - Permissão de trabalho em altura"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Calçado de segurança tipo botina", "Capacete com ABA", "Capacete de Segurança ultra master", "Luva de raspa cano curto"),
            medidasAdm = "Procedimentos operacionais internos, Treinamento de ordem de serviço."
        )
    ),
    cargos = listOf(
        PgrCargo("Auxiliar de eletrica", "Auxiliar na montagem e instalação de estruturas elétricas, incluindo postes, torres, eletrocalhas, leitos Apoiar na passagem de cabos e fios elétricos, Organizar ferramentas, equipamentos e materiais no canteiro de obras Realizar escavações e apoio a atividades civis relacionadas à instalação elétrica, Auxiliar na fixação de suportes, isoladores e componentes elétricos, Apoiar eletricistas em testes simples e inspeções, Zelar pela limpeza e organização da área de trabalho, Cumprir procedimentos de segurança, uso de EPIs e normas da empresa, Apoiar na sinalização de área e isolamento"),
        PgrCargo("Eletricista", "Realizar instalações elétricas, Realizar manutenções e revisões elétricas, Utilizar equipamentos para medições"),
        PgrCargo("Eletricista Força e Controle", "Realizar a montagem, instalação e manutenção de painéis de força e controle elétrico. Interpretar esquemas elétricos, diagramas unifilares, trifilares e de comando. Instalar eletro calhas, eletro dutos, dutos e leitos para passagem de cabos. Conectar motores elétricos, sensores, botoeiras, disjuntores, inversores de frequência e outros dispositivos de automação. Efetuar testes e medições elétricas com uso de multímetro, megômetro e alicate amperímetro. Identificar e corrigir falhas em sistemas de força e de controle. Trabalhar conforme normas técnicas e de segurança (NR-10, NR-35, etc.). Realizar a limpeza e organização da área de trabalho após os serviços."),
        PgrCargo("Encarregado de elétrica", "Administram equipes, metas e resultados de manutenção eletroeletrônica industrial, comercial e predial. Elaboram orçamento, planejam as atividades e controlam o processo para sua realização. Elaboram documentação técnica e zelam pela segurança, saúde e meio ambiente."),
        PgrCargo("Meio oficial eletricista", "Planejam serviços elétricos, realizam instalação de distribuição de alta e baixa tensão. Montam e reparam instalações elétricas e equipamentos auxiliares em residências, estabelecimentos industriais, comerciais e de serviços. Instalam e reparam equipamentos de iluminação de cenários ou palcos.")
    )
)

private fun pgrSetor04() = PgrSetor(
    ghe = 4,
    nome = "Limpeza",
    descricao = "Limpeza das áreas em geral.",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor auditivo"),
            medidasAdm = "Treinamento de ordem de serviço, ficha de entrega de EPI´s."
        ),
        PgrRisco(
            grupo = "Químico",
            perigo = "Produtos Saneantes e Domissanitários",
            danos = "Irritação da pele e olhos, alguns produtos podem causar irritação leve do trato respiratório, se manipulados em local fechado ou sem proteção individual.",
            epc = emptyList(),
            epi = listOf("Luva de Neolatex"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Biológico",
            perigo = "Limpeza e conservação (banheiros e áreas de trabalho)",
            danos = "Salmonelose, campilobacteriose, Bacilus cereus, Escherichia coli, Staphilocos aureos, Fecalis.",
            epc = emptyList(),
            epi = listOf("Luva de Neolatex"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "AET (Analise Ergonômica do trabalho) Responsável pela Elaboração do AET Ezequiel Cabral de Souza Lima Medico do Trabalho CRM 24773-SC / RQE 15303"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Limpeza e conservação predial",
            danos = "Fraturas, ferimentos nos olhos, membros superiores e inferiores.",
            epc = emptyList(),
            epi = listOf("Luva de Neolatex"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área administrativa",
            danos = "Acidentes: Torções, Ferimentos leves. Posturas incorretas: Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = ""
        )
    ),
    cargos = listOf(
        PgrCargo("Auxiliar de Serviços Gerais", "Executar trabalhos de limpeza geral para manutenção das condições de higiene e conservação do canteiro de obras.")
    )
)

private fun pgrSetor05() = PgrSetor(
    ghe = 5,
    nome = "Logística",
    descricao = "Transporte de cargas e pessoas",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo", "Protetor auditivo"),
            medidasAdm = "Procedimentos operacionais intenos, ficha de entrega de EPI."
        ),
        PgrRisco(
            grupo = "Físico",
            perigo = "Vibração de corpo inteiro (aceleração resultante de exposição normalizada - AREN)",
            danos = "Alterações neurológicas e/ou neuromusculares.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Físico",
            perigo = "Vibração de corpo inteiro (Valor da Dose de Vibração Resultante - VDVR)",
            danos = "Alterações neurológicas e/ou neuromusculares.",
            epc = listOf("Sistema de amortecimento nos bancos"),
            epi = emptyList(),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "Treinamento de ordem de serviço, procedimento operacional interno, Ficha de entrega de EPI´s"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Calçado de segurança tipo botina", "Capacete Classe B", "Capacete classe E suspensão com jugular", "Luva de Neolatex", "Óculos de Proteção"),
            medidasAdm = "Treinamento de ordem de serviço, procedimento operacional interno, Ficha de entrega de EPI´s"
        )
    ),
    cargos = listOf(
        PgrCargo("Motorista", "Observar as normas de trânsito Responsabilizar-se pelo transporte de passageiros e cargas Realizar verificações e manutenções básicas do veículo, Inspecionar as condições do veículo Manter o interior e as janelas do carro limpos, Certificar-se de ter sempre gasolina suficiente para chegar ao destino, Manter registo preciso do consumo de gasolina, quilometragem e outros dados, Verificar trajetos assegurando a regularidade do transporte"),
        PgrCargo("Motorista de Munck", "Operar veículos equipados com um guindaste articulado (Munck), utilizado para carregar e descarregar cargas, movimentar materiais e equipamentos em diferentes locais. Operar os controles do Munck, garantir a segurança durante o manuseio de cargas, seguir procedimentos de segurança e realizar a manutenção básica do equipamento."),
        PgrCargo("Motorista de Transporte de Passageiros", "Motorista de Transporte de Passageiros.")
    )
)

private fun pgrSetor06() = PgrSetor(
    ghe = 6,
    nome = "Montagem - Trabalho em Altura",
    descricao = "Montagem de equipamentos em campo",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo", "Protetor auditivo"),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Químico",
            perigo = "Contato com produtos químicos",
            danos = "Pode causar irritação na pele e olhos (se contato direto).",
            epc = emptyList(),
            epi = listOf("Luva de Neolatex", "Respirador de Ar Semi Facial - 4115"),
            medidasAdm = "DDS, Treinamento de ordem de serviço, ficha de entrega de EPI´s, procedimentos operacional interno."
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "AET (Analise Ergonômica do trabalho) Responsável pela Elaboração do AET Ezequiel Cabral de Souza Lima Medico do Trabalho CRM 24773-SC / RQE 15303"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em altura",
            danos = "Morte, Poli traumatismos (Contusões/Fraturas).",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Capacete", "Cinturão de segurança com talabarte ou trava-queda", "Luva contra agentes mecânicos", "Óculos de segurança"),
            medidasAdm = "Treinamento de NR 35 aos colaboradores. PTA - Permissão de trabalho em altura"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Luva contra agentes mecânicos"),
            medidasAdm = ""
        )
    ),
    cargos = listOf(
        PgrCargo("Encarregado de Montagem", "Acompanhar atividades da equipe de montagem, montar estruturas, realizar separação de materiais e envolvidos em montagem, acompanhar cronogramas, realizar leitura de projetos."),
        PgrCargo("Líder de Montagem de EST", "Executar a liderança da equipe de montagem, seguindo desenhos e especificações, utilizando equipamentos de içar e transportar e outros apetrechos apropriados, para obter produtos acabados destinados à construção de edifícios, pontes, torres de sondagem e outras obras."),
        PgrCargo("Meio Oficial Montador", "Auxiliam na Pré-montagem, montagem eletromecânica e de estruturas metálicas lançamento e nivelamento de cabos, fixação, montagem de torres, instalação de isoladores tanto em obras de subestação de energia quanto em linha de transmissão."),
        PgrCargo("Montador", "Executar montagem de componentes de estruturas metálicas, seguindo desenhos e especificações, utilizando equipamentos de içar e transportar e outros apetrechos apropriados, para obter produtos acabados destinados à construção de edifícios, pontes, torres de sondagem e outras obras. Responsabilidades mais amplas."),
        PgrCargo("Montador I", "Executar montagem de componentes de estruturas metálicas, seguindo desenhos e especificações, utilizando equipamentos de içar e transportar e outros apetrechos apropriados, para obter produtos acabados destinados à construção de edifícios, pontes, torres de sondagem e outras obras. Responsabilidades mais amplas")
    )
)

private fun pgrSetor07() = PgrSetor(
    ghe = 7,
    nome = "Obra - Administrativo",
    descricao = "Controle e orientação de equipes de trabalho",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo"),
            medidasAdm = "Treinamento de ordem de serviço, ficha de entrega de EPI´s, procedimento operacionais interno."
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "AET (Analise Ergonômica do trabalho) - Responsável pela Elaboração do AET Ezequiel Cabral de Souza Lima Medico do Trabalho CRM 24773-SC / RQE 15303"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Calçado de segurança tipo botina", "Luva de Neolatex"),
            medidasAdm = "Treinamento de ordem de serviço, procedimento operacional interno, Ficha de entrega de EPI´s"
        )
    ),
    cargos = listOf(
        PgrCargo("Analista administrativo de obras", "Planejam, organizam, controlam e assessoram as organizações nas áreas de recursos humanos, patrimônio, materiais, informações, financeira, tecnológica, entre outras, implementam programas e projetos, elaboram planejamento organizacional, promovem estudos de racionalização e controlam o desempenho organizacional. Prestam consultoria administrativa a organizações e pessoas."),
        PgrCargo("Analista administrativo de obras PL", "Planejam, organizam, controlam e assessoram as organizações nas áreas de recursos humanos, patrimônio, materiais, informações, financeira, tecnológica, entre outras, implementam programas e projetos, elaboram planejamento organizacional, promovem estudos de racionalização e controlam o desempenho organizacional. Prestam consultoria administrativa a organizações e pessoas."),
        PgrCargo("Assistente Administrativo de Obras", "Executa serviços de apoio nas áreas de recursos humanos, administração, finanças e logística, atendem fornecedores e clientes, fornecendo e recebendo informações sobre produtos e serviços, tratam de documentos variados, cumprindo todo o procedimento necessário referente aos mesmos, preparam relatórios e planilhas."),
        PgrCargo("Assistente de Engenharia", "Auxiliar e acompanhar a programação das atividades e produção de cronograma da obra, acompanhar e conferir a execução e qualidade dos serviços, listar máquinas, equipamentos e ferramentas usados na obra, controlar e atualizar documentação de obra, controlar estoque dos materiais, cotar preços de insumos e serviços e selecionar fornecedores, elaborar relatórios técnicos, corrigir as não-conformidades, fazer diário de obras, realizar serviços de acordo com normas de higiene, saúde e segurança no trabalho, Colaborar com as medições, acompanhar os resultados dos serviços, conferir pedidos e notas fiscais recebidas."),
        PgrCargo("Engenheiro", "Responsável por planejar, projetar, executar e acompanhar obras e construções. Suas principais atividades incluem o desenvolvimento de projetos, a supervisão da construção, a análise de materiais e custos, a gestão de equipes de trabalho, e a garantia da qualidade e segurança nas obras"),
        PgrCargo("Engenheiro Eletricista", "Executam serviços elétricos, eletrônicos e de telecomunicações, analisando propostas técnicas, instalando, configurando e inspecionando sistemas e equipamentos, executando testes e ensaios. Projetam, planejam e especificam sistemas e equipamentos elétricos, eletrônicos e de telecomunicações e elaboram sua documentação técnica, coordenam empreendimentos e estudam processos elétricos, eletrônicos e de telecomunicações."),
        PgrCargo("Engenheiro Residente", "Desenvolver projetos de engenharia, executar obras, planejar, orçar e contratar empreendimentos, coordenar a operação e a manutenção dos mesmos. Controlar a qualidade dos suprimentos e serviços comprados e executados."),
        PgrCargo("Site Manager", "Desenvolver projetos de engenharia, executar obras, planejar, orçar e contratar empreendimentos, coordenar a operação e a manutenção dos mesmos. Controlar a qualidade dos suprimentos e serviços comprados e executados.")
    )
)

private fun pgrSetor08() = PgrSetor(
    ghe = 8,
    nome = "Obra - Operacional",
    descricao = "Serviços de alvenaria em geral",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo", "Protetor auditivo"),
            medidasAdm = "Procedimentos operacionais internos, ficha de entrega de EPI."
        ),
        PgrRisco(
            grupo = "Físico",
            perigo = "Vibração localizada de mão e braço",
            danos = "Alterações neurológicas e/ou neuromusculares.",
            epc = emptyList(),
            epi = listOf("Luva anti - vibração"),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Químico",
            perigo = "Contato com produtos químicos",
            danos = "Pode causar irritação na pele e olhos (se contato direto).",
            epc = emptyList(),
            epi = listOf("Luva de Neolatex", "Respirador de Ar Semi Facial - 4115"),
            medidasAdm = "DDS, Treinamento de ordem de serviço, ficha de entrega de EPI´s, procedimentos operacionais internos."
        ),
        PgrRisco(
            grupo = "Químico",
            perigo = "Poeiras respiráveis (PNOS)",
            danos = "Rinite alérgica, podem causar hipersensibilidade podendo desenvolver e/ou agravar doenças como bronquites alérgicas, pneumonias.",
            epc = emptyList(),
            epi = listOf("Respirador descartável PFF-2"),
            medidasAdm = "Treinamento de ordem de serviço, procedimento operacional interno, Ficha de entrega de EPI´s"
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "AET (Analise Ergonômica do trabalho) Responsável pela Elaboração do AET Ezequiel Cabral de Souza Lima Medico do Trabalho CRM 24773-SC / RQE 15303"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Calçado de segurança tipo botina", "Luva de Neolatex"),
            medidasAdm = "Treinamento de ordem de serviço, procedimento operacional interno, Ficha de entrega de EPI´s"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho na construção civil",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face, Efeitos locais e/ou sistêmicos (tóxicos/alérgicos) por contato ou picada de animais peçonhentos.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Calçado de segurança tipo botina", "Capacete Classe B", "Capacete classe E suspensão com jugular", "Luva de segurança, anti-vibração, tricotada de algodão", "Óculos de Proteção"),
            medidasAdm = "Ficha de entrega de EPI, Treinamento sobre uso de EPI, Ordem de Serviços, Procedimentos operacionais internos."
        )
    ),
    cargos = listOf(
        PgrCargo("Ajudante", "Executar atividades práticas e de suporte em canteiros de obras e locais de construção, suporte operacional, realizando uma variedade de tarefas de auxílio aos oficiais e outros profissionais qualificados."),
        PgrCargo("Apontador de Obra", "Realizar o controle e o registro das atividades operacionais no canteiro de obras. Dar suporte administrativo e na gestão das equipes de trabalho. Auxiliar no controle de ponto. Auxiliar no monitoramento de jornadas, faltas, atrasos e horas extras. Anotar e reportar ao gestor as atividades executadas pelos colaboradores. Fornecer informações para o controle de produtividade. Controlar a entrada e saída de materiais no canteiro de obras. Verificar a disponibilidade de ferramentas e equipamentos. Elaborar relatórios diários de obra, com informações sobre a evolução dos trabalhos. Servir como elo entre o escritório administrativo e equipes no canteiro de obras, transmitindo informações relevantes."),
        PgrCargo("Auxiliar de Pedreiro", "Limpar local de trabalho, Preparar canteiro de obras, Realizar carga e descarga, Limpar equipamentos, Preparar massa de concreto."),
        PgrCargo("Encarregado Civil", "Desempenhar papel de confiança e liderança transitoriamente, assumindo a responsabilidade pela supervisão e coordenação eficaz das operações de construção civil e instalação de placas solares."),
        PgrCargo("Líder de Civil", "Supervisionar colaboradores, distribuir atividades, acompanhar cronograma e medições de obras, controlar e fazer vistoria em equipamentos, pesquisar prestadores serviços e matéria-prima, participar na compra de suprimentos."),
        PgrCargo("Meio Ofical Pedreiro", "Desempenhar um papel intermediário nas operações de construção civil e instalação de placas solares, operando sob a orientação e fiscalização do oficial ou do Sub Encarregado."),
        PgrCargo("Meio Oficial", "Desempenhar um papel intermediário nas operações de construção civil e instalação de placas solares, operando sob a orientação e fiscalização do oficial ou do Sub Encarregado."),
        PgrCargo("Pedreiro", "Organizar e preparar o local de trabalho. Construir fundações e estruturas"),
        PgrCargo("Sub Encarregado", "Desempenhar uma função transitória de liderança em projetos de construção civil e instalação de placas solares, reunindo condições técnicas necessárias para assumir responsabilidades mais amplas.")
    )
)

private fun pgrSetor09() = PgrSetor(
    ghe = 9,
    nome = "Obra - Operacional (Trabalho em Altura)",
    descricao = "Serviços de alvenaria em geral, e atividades am altura",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo"),
            medidasAdm = "Procedimentos operacionais internos, ficha de entrega de EPI´s."
        ),
        PgrRisco(
            grupo = "Físico",
            perigo = "Vibração localizada de mão e braço",
            danos = "Alterações neurológicas e/ou neuromusculares.",
            epc = emptyList(),
            epi = listOf("Luva anti - vibração", "Luva de segurança, anti-vibração, tricotada de algodão"),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Químico",
            perigo = "Contato com produtos químicos",
            danos = "Pode causar irritação na pele e olhos (se contato direto).",
            epc = emptyList(),
            epi = listOf("Luva de Neolatex", "Respirador de Ar Semi Facial - 4115"),
            medidasAdm = "DDS, Treinamento de ordem de serviço, ficha de entrega de EPI´s, procedimentos operacionais internos."
        ),
        PgrRisco(
            grupo = "Químico",
            perigo = "Poeiras respiráveis (PNOS)",
            danos = "Rinite alérgica, podem causar hipersensibilidade podendo desenvolver e/ou agravar doenças como bronquites alérgicas, pneumonias.",
            epc = emptyList(),
            epi = listOf("Respirador descartável PFF-2"),
            medidasAdm = "Treinamento de ordem de serviço, procedimento operacional interno, Ficha de entrega de EPI´s"
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "AET (Analise Ergonômica do trabalho) Responsável pela Elaboração do AET Ezequiel Cabral de Souza Lima Medico do Trabalho CRM 24773-SC / RQE 15303"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em altura",
            danos = "Morte, Poli traumatismos (Contusões/Fraturas).",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Capacete B com carneira e jugular", "Capacete classe E suspensão com jugular", "Luva de Neolatex", "Luva de raspa cano curto", "Óculos de Proteção"),
            medidasAdm = "Treinamento de NR 35 aos colaboradores. PTA - Permissão de trabalho em altura"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Calçado de segurança tipo botina"),
            medidasAdm = "Treinamento de ordem de serviço, procedimento operacional interno, Ficha de entrega de EPI´s"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho na construção civil",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face, Efeitos locais e/ou sistêmicos (tóxicos/alérgicos) por contato ou picada de animais peçonhentos.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Calçado de segurança tipo botina", "Capacete Classe B", "Capacete classe E suspensão com jugular", "Luva de segurança, anti-vibração, tricotada de algodão", "Óculos de Proteção"),
            medidasAdm = "Ficha de entrega de EPI, Treinamento sobre uso de EPI, Ordem de Serviços, Procedimentos operacionais internos."
        )
    ),
    cargos = listOf(
        PgrCargo("Ajudante", "Executar atividades práticas e de suporte em canteiros de obras e locais de construção, suporte operacional, realizando uma"),
        PgrCargo("Pedreiro", "Organizar e preparar o local de trabalho. Construir fundações e estruturas")
    )
)

private fun pgrSetor10() = PgrSetor(
    ghe = 10,
    nome = "Obra - Operacional Armações",
    descricao = "Montagem de armações para serviços de campo",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo", "Protetor auditivo"),
            medidasAdm = "Procedimentos operacionais internos, ficha de entrega de EPI."
        ),
        PgrRisco(
            grupo = "Físico",
            perigo = "Vibração localizada de mão e braço",
            danos = "Alterações neurológicas e/ou neuromusculares.",
            epc = emptyList(),
            epi = listOf("Luva anti - vibração", "Luva de segurança, anti-vibração, tricotada de algodão"),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Químico",
            perigo = "Poeiras respiráveis (PNOS)",
            danos = "Rinite alérgica, podem causar hipersensibilidade podendo desenvolver e/ou agravar doenças como bronquites alérgicas, pneumonias.",
            epc = emptyList(),
            epi = listOf("Respirador descartável PFF-2"),
            medidasAdm = "Treinamento de ordem de serviço, procedimento operacional interno, Ficha de entrega de EPI´s"
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "AET (Analise Ergonômica do trabalho) Responsável pela Elaboração do AET Ezequiel Cabral de Souza Lima Medico do Trabalho CRM 24773-SC / RQE 15303"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Luva contra agentes mecânicos"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho na construção civil",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face, Efeitos locais e/ou sistêmicos (tóxicos/alérgicos) por contato ou picada de animais peçonhentos.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Calçado de segurança tipo botina", "Luva de segurança, anti-vibração, tricotada de algodão", "Óculos de Proteção"),
            medidasAdm = "Ficha de entrega de EPI, Treinamento sobre uso de EPI, Ordem de Serviços, Procedimentos operacionais internos."
        )
    ),
    cargos = listOf(
        PgrCargo("Armador", "Responsável por montar e instalar estruturas de concreto e ferro em obras da construção civil. Utilizando ferramentas e equipamentos específicos para realizar a amarração e posicionamento correto das armaduras, garantindo a segurança e estabilidade das estruturas."),
        PgrCargo("Sub Encarregado", "Desempenhar uma função transitória de liderança em projetos de construção civil e instalação de placas solares, reunindo condições técnicas necessárias para assumir responsabilidades mais amplas.")
    )
)

private fun pgrSetor11() = PgrSetor(
    ghe = 11,
    nome = "Obra - Operacional Carpintaria",
    descricao = "Fabricação de caixaria e peças para serviços de campo",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo", "Protetor auditivo"),
            medidasAdm = "Procedimentos operacionais internos, ficha de entrega de EPI."
        ),
        PgrRisco(
            grupo = "Físico",
            perigo = "Vibração localizada de mão e braço",
            danos = "Alterações neurológicas e/ou neuromusculares.",
            epc = emptyList(),
            epi = listOf("Luva anti - vibração"),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Químico",
            perigo = "Poeiras respiráveis (PNOS)",
            danos = "Rinite alérgica, podem causar hipersensibilidade podendo desenvolver e/ou agravar doenças como bronquites alérgicas, pneumonias.",
            epc = emptyList(),
            epi = listOf("Respirador descartável PFF-2"),
            medidasAdm = "Treinamento de ordem de serviço, procedimento operacional interno, Ficha de entrega de EPI´s"
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "AET (Analise Ergonômica do trabalho) Responsável pela Elaboração do AET Ezequiel Cabral de Souza Lima Medico do Trabalho CRM 24773-SC / RQE 15303"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensidade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Calçado de segurança tipo botina", "Luva de Neolatex"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho na construção civil",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face, Efeitos locais e/ou sistêmicos (tóxicos/alérgicos) por contato ou picada de animais peçonhentos.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Calçado de segurança tipo botina", "Luva de segurança, anti-vibração, tricotada de algodão", "Óculos de Proteção"),
            medidasAdm = "Ficha de entrega de EPI, Treinamento sobre uso de EPI, Ordem de Serviços, Procedimentos operacionais internos."
        )
    ),
    cargos = listOf(
        PgrCargo("Carpinteiro", "Responsável por construir e montar cacharia. Utilizar ferramentas manuais e elétricas, seguir projetos e zelar pela segurança no trabalho.")
    )
)

private fun pgrSetor12() = PgrSetor(
    ghe = 12,
    nome = "Obra - Supervisão",
    descricao = "Controle e orientação de equipes de trabalho",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo"),
            medidasAdm = "Treinamento de ordem de serviço, ficha de entrega de EPI´s, procedimento operacionais interno."
        ),
        PgrRisco(
            grupo = "Físico",
            perigo = "Vibração de corpo inteiro (aceleração resultante de exposição normalizada - AREN)",
            danos = "Alterações neurológicas e/ou neuromusculares.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Físico",
            perigo = "Vibração de corpo inteiro (Valor da Dose de Vibração Resultante - VDVR)",
            danos = "Alterações neurológicas e/ou neuromusculares.",
            epc = listOf("Sistema de amortecimento nos bancos"),
            epi = emptyList(),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "AET (Analise Ergonômica do trabalho) Responsável pela Elaboração do AET Ezequiel Cabral de Souza Lima Medico do Trabalho CRM 24773-SC / RQE 15303"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Luva contra agentes mecânicos"),
            medidasAdm = ""
        )
    ),
    cargos = listOf(
        PgrCargo("Coordenador de obras", "Gerencia obras na interface entre construtora e incorporadora. Aponta e propõe ações de correção. Reporta ao escritório tudo o que diz respeito a obra que passe por suas mãos. Acompanha e fiscaliza as obras, presta suporte no acompanhamento de custos e realiza o planejamento."),
        PgrCargo("Encarregado de Obras", "Desempenhar um papel de confiança e liderança transitoriamente na empresa, sendo fundamental para responder perante os órgãos de fiscalização, elaborar programações, gerenciar o campo de operações e confeccionar medições em projetos de construção civil e instalação de placas solares."),
        PgrCargo("Encarregado geral", "Supervisionar cada uma das etapas de execução de projetos construtivos, Fiscalizar a execução do planejamento da obra, Coordenar equipes de em canteiros de obras, Controlar recursos produtivos, Administrar o cronograma das atividades"),
        PgrCargo("Gerente de construção", "Gerencia obras na interface entre construtora e incorporadora. Aponta e propõe ações de correção. Reporta ao escritório tudo o que diz respeito a obra que passe por suas mãos. Acompanha e fiscaliza as obras, presta suporte no acompanhamento de custos e realiza o planejamento."),
        PgrCargo("Gerente de Obras", "Gerencia obras na interface entre construtora e incorporadora. Aponta e propõe ações de correção. Reporta ao escritório tudo o que diz respeito a obra que passe por suas mãos. Acompanha e fiscaliza as obras, presta suporte no acompanhamento de custos e realiza o planejamento."),
        PgrCargo("Supervisor de Obras", "Acompanhar, supervisionar e executar as obras de implantação de new sites, montagens de estruturas metálicas, reforços de estruturas e fundação.")
    )
)

private fun pgrSetor13() = PgrSetor(
    ghe = 13,
    nome = "Operações e construção",
    descricao = "Operação de máquinas em campo",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo", "Protetor auditivo"),
            medidasAdm = "Procedimentos operacionais intenos, ficha de entrega de EPI."
        ),
        PgrRisco(
            grupo = "Físico",
            perigo = "Vibração de corpo inteiro (aceleração resultante de exposição normalizada - AREN)",
            danos = "Alterações neurológicas e/ou neuromusculares.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Físico",
            perigo = "Vibração de corpo inteiro (Valor da Dose de Vibração Resultante - VDVR)",
            danos = "Alterações neurológicas e/ou neuromusculares.",
            epc = listOf("Sistema de amortecimento nos bancos"),
            epi = emptyList(),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Movimentação mecânica de cargas",
            danos = "Tombamento: Politraumatismos ou morte. Batidas contra/ Queda sobre: Fraturas, ferimentos, morte.",
            epc = emptyList(),
            epi = listOf("Capacete Classe B", "Capacete classe E suspensão com jugular"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho com operação de plataformas elevatória",
            danos = "Lesões provocadas por batida contra objetos",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Calçado de segurança tipo botina", "Capacete classe E suspensão com jugular", "Cinto de Seg.tipo Paraquedista e Talabarte de Segurança", "Cinto de Segurança tipo Paraquedista com Talabarte y", "Luva de segurança confeccionada em raspa", "Luva de segurança, anti-vibração, tricotada de algodão"),
            medidasAdm = "Treinamento de ordem de serviço, ficha de entrega de EPI´s, procedimentos operacionais internos, Treinamento conforme NR 18 e NR 11."
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Luva contra agentes mecânicos"),
            medidasAdm = ""
        )
    ),
    cargos = listOf(
        PgrCargo("Motorista de Munck", "Operar veículos equipados com um guindaste articulado (Munck), utilizado para carregar e descarregar cargas, movimentar materiais e equipamentos em diferentes locais. Operar os controles do Munck, garantir a segurança durante o manuseio de cargas, seguir procedimentos de segurança e realizar a manutenção básica do equipamento."),
        PgrCargo("Motorista de Operador Guindauto", "Operar veículos equipados com um guindaste articulado (Munck), utilizado para carregar e descarregar cargas, movimentar materiais e equipamentos em diferentes locais. Operar os controles do Munck, garantir a segurança durante o manuseio de cargas, seguir procedimentos de segurança e realizar a manutenção básica do equipamento"),
        PgrCargo("Motorista operador", "Conduzir e operar veículos motorizados para transportar pessoas, cargas ou valores, Realizar verificações e manutenções básicas do veículo, Vistoriar o veículo sob sua responsabilidade, Dirigir o veículo observando as normas de trânsito, responsabilizando-se pelos usuários, carga e equipamentos do veículo, Providenciar a manutenção do veículo, comunicando as falhas e solicitando os reparos necessários, efetuar reparos de emergência no veículo"),
        PgrCargo("Operador de Maquinas", "Responsável por operar diversos tipos de equipamentos e maquinários utilizados nas obras. Sua principal função é manusear com"),
        PgrCargo("Operador de Retroescavadeira", "Escavar trincheiras, poços, valas e outros locais Remover terra, pedras, areia, cascalho e outros materiais Construir aterros e desaterros Realizar acabamento em pavimentos Cravar estacas, Demolir construções que não serão aproveitadas, Retirar entulhos, Transportar materiais")
    )
)

private fun pgrSetor14() = PgrSetor(
    ghe = 14,
    nome = "Portaria",
    descricao = "Atendimento a portaria e controle de acessos",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo"),
            medidasAdm = "Procedimento operacional interno, ficha de entrega de EPI, treinamento de ordem de serviço."
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "AET (Analise Ergonômica do trabalho) Responsável pela Elaboração do AET Ezequiel Cabral de Souza Lima Medico do Trabalho CRM 24773-SC / RQE 15303"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de Portaria",
            danos = "Ferimentos, morte.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = ""
        )
    ),
    cargos = listOf(
        PgrCargo("Porteiro", "Responsável por controlar o acesso de pessoas, veículos e materiais do canteiro de obras. Suas principais atividades incluem registrar a entrada e saída de funcionários e visitantes, garantir a segurança do local, orientar e direcionar os visitantes para as áreas adequadas, controlar o recebimento e saída de materiais, zelar pelo patrimônio da obra e auxiliar em atividades administrativas relacionadas à portaria.")
    )
)

private fun pgrSetor15() = PgrSetor(
    ghe = 15,
    nome = "Segurança do trabalho",
    descricao = "Manutenção de documentos e acompanhamento de equipes em frentes de trabalho.",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo", "Protetor auditivo"),
            medidasAdm = "Procedimentos operacionais internos, ficha de entrega de EPI."
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "AET (Analise Ergonômica do trabalho) Responsável pela Elaboração do AET Ezequiel Cabral de Souza Lima Medico do Trabalho CRM 24773-SC / RQE 15303"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Luva contra agentes mecânicos"),
            medidasAdm = ""
        )
    ),
    cargos = listOf(
        PgrCargo("Analista SESMT", "Desenvolver ações educativas na área de saúde e segurança no trabalho, participar de perícias e fiscalizações e integram processos de negociação. Participar da adoção de tecnologias e processos de trabalho, gerenciar documentação de SST, investigar, analisar acidentes e recomendar medidas de prevenção e controle"),
        PgrCargo("Assistente de SESMT", "Auxilia na aplicação dos procedimentos de segurança do trabalho e orienta os colaboradores e prestadores de serviços quanto ao uso adequado de equipamentos de proteção individual, a fim de garantir a integridade dos funcionários e do patrimônio da empresa"),
        PgrCargo("Técnico em QSMS", "Acompanhar e orientar as atividades em campo quanto às normas de Saúde e Segurança do Trabalho, Meio Ambiente e Qualidade, Realizar inspeções de segurança, auditorias internas e verificações de conformidade em canteiros de obras e áreas operacionais, Identificar riscos, propor medidas de controle e acompanhar a implementação de ações corretivas e preventivas, Apoiar a elaboração e o cumprimento de documentos legais e técnicos, como: APR, PT, PGR, PCMSO, relatórios ambientais e registros de qualidade, Controlar o uso adequado de EPIs e EPCs, orientando colaboradores e terceiros, Ministrar e apoiar treinamentos, DDS e campanhas de conscientização em QSMA, Acompanhar incidentes, acidentes e quase acidentes, participando da investigação e elaboração de relatórios, Monitorar o atendimento às normas regulamentadoras (NRs) e legislações ambientais aplicáveis, Apoiar a gestão de resíduos, controle ambiental e boas práticas sustentáveis,"),
        PgrCargo("Técnico em segurança do trabalho", "Inspeciona as atividades realizadas na instituição, observando aspectos ligados à segurança do trabalho, visando assegurar condições que eliminem ou reduzam ao mínimo os riscos de ocorrência de acidentes de trabalho, atentando ao cumprimento de legislação pertinente.")
    )
)

private fun pgrSetor16() = PgrSetor(
    ghe = 16,
    nome = "Segurança do Trabalho (Trabalho em altura / Espaço confinado)",
    descricao = "Manutenção de documentos, acompanhamento de equipes, Trabalho em altura e em espaço confinado.",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo", "Protetor auditivo"),
            medidasAdm = "Procedimentos operacionais internos, ficha de entrega de EPI."
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Espaço Confinado",
            danos = "Sufocamento/Asfixia/Intoxicaçãopor gases, poeiras, vapores, e/ou altas temperaturas. Incêndio, explosão, choque elétrico, queda, entre outros que possam afetar a segurança do trabalhador (conforme atividade / ambiente)",
            epc = listOf("Tripé, sistema de resgata de espaço confinado, monitoramento de gases, sistema de ar forçado (insuflador)."),
            epi = listOf("Calçado de segurança", "Capacete de Segurança ultra master", "Respirador facial inteira Cartucho químico para respirador"),
            medidasAdm = "Treinamento de ordem de serviço, procedimento operacional interno, Ficha de entrega de EPI´s"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em altura",
            danos = "Morte, Poli traumatismos (Contusões/Fraturas).",
            epc = listOf("Corda linha de vida", "Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança", "Calçado de segurança tipo botina", "Cinto de Seg.tipo Paraquedista e Talabarte de Segurança", "Cinturão de Segurança com Talabarte Ou Trava-Queda", "Luva de Neolatex", "Luva de segurança raspa"),
            medidasAdm = "Procedimentos Operacionais internos, Treinamento de NR 35 aos colaboradores, Treinamento de ordem de serviço. PTA - Permissão de trabalho em altura"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Luva de Neolatex"),
            medidasAdm = "Treinamento de ordem de serviço, procedimento operacional interno, Ficha de entrega de EPI´s"
        )
    ),
    cargos = listOf(
        PgrCargo("Técnico em segurança do trabalho", "Inspeciona as atividades realizadas na instituição, observando aspectos ligados à segurança do trabalho, visando assegurar condições que eliminem ou reduzam ao mínimo os riscos de ocorrência de acidentes de trabalho, atentando ao cumprimento de legislação pertinente.")
    )
)

private fun pgrSetor17() = PgrSetor(
    ghe = 17,
    nome = "Subcontratados",
    descricao = "Serviços diversos, as atividades podem variar conforme perfil da Obra e necessidade de Contratação. Atendendo ao item 1.5.8.1.1 (No caso de utilização dos programas das organizações contratadas, estas devem fornecer à organização contratante o inventário de riscos ocupacionais e o plano de ação referente às atividades objeto de sua contratação.), O inventário de riscos disponibilizado pela contratada está disponível no caderno de anexos deste documento.",
    riscos = listOf(
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Luva contra agentes mecânicos"),
            medidasAdm = ""
        )
    ),
    cargos = listOf(
        PgrCargo("Subcontratados", "Realizar atividades conforme função, atender as normas e regras internas do local de trabalho, Respeitar as lideranças e profissionais de segurança do trabalho, prezar pelo meio ambiente, respeitar as politicas internas da Empresa HTMS SOLAR ltda.")
    )
)

private fun pgrSetor18() = PgrSetor(
    ghe = 18,
    nome = "Topografia",
    descricao = "Serviços de topografiam em campo",
    riscos = listOf(
        PgrRisco(
            grupo = "Físico",
            perigo = "Ruído Contínuo ou Intermitente",
            danos = "Irritabilidade, dor de cabeça, mal-estar, podendo causar perda auditiva conforme intensidade do ruído associado ao tempo de exposição sem proteção.",
            epc = emptyList(),
            epi = listOf("Protetor Auditivo", "Protetor auditivo"),
            medidasAdm = "Procedimentos operacionais internos, ficha de entrega de EPI."
        ),
        PgrRisco(
            grupo = "Ergonômico",
            perigo = "Exposição a Fatores Ergonômicos",
            danos = "Comprometimento neuromuscular e/ou ósteo-articular e/ou circulatório.",
            epc = emptyList(),
            epi = emptyList(),
            medidasAdm = "AET (Analise Ergonômica do trabalho) Responsável pela Elaboração do AET Ezequiel Cabral de Souza Lima Medico do Trabalho CRM 24773-SC / RQE 15303"
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Choque elétrico",
            danos = "O contato com a eletricidade, pode causar formigamento, queimaduras de 3º grau, amputação, óbito conforme a intensdade.",
            epc = listOf("Corrente Plastica Isolamento / Cones / Fitas"),
            epi = listOf("Calçado de segurança NR 10", "Capacete de Segurança ultra master", "Uniformes RF (Retardante à Chama)"),
            medidasAdm = ""
        ),
        PgrRisco(
            grupo = "Acidente",
            perigo = "Trabalho em área de operação",
            danos = "Torções, Ferimentos, ou traumatismos lacero-contusos nos membros superiores ou inferiores, nos olhos ou face.",
            epc = emptyList(),
            epi = listOf("Calçado de segurança", "Luva contra agentes mecânicos"),
            medidasAdm = ""
        )
    ),
    cargos = listOf(
        PgrCargo("Auxiliar de Topografia", "Prestar suporte ao trabalho dos topógrafos, auxiliando nas atividades de medição, marcação e levantamento topográfico. Suas principais funções incluem a preparação e organização dos equipamentos e instrumentos de medição, a realização de medições simples, a coleta de dados e informações em campo, bem como a elaboração de relatórios e registros relacionados ao trabalho topográfico."),
        PgrCargo("Topografo", "Responsável por realizar levantamentos topográficos e geodésicos, coletando dados e informações para a elaboração de projetos de engenharia. Sua principal atividade é realizar medições precisas do terreno, utilizando equipamentos específicos, como teodolitos e estação total. Interpretar os dados coletados para criar mapas, plantas e modelos tridimensionais, garantindo a precisão e a qualidade das informações para a execução de obras e projetos.")
    )
)
